var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogNetworkDefault = function SvgLogNetworkDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19340_58129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13H5.33333",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.6666H3.33333C2.59667 14.6666 2 14.07 2 13.3333V8.66665C2 7.92998 2.59667 7.33331 3.33333 7.33331H6C6.73667 7.33331 7.33333 7.92998 7.33333 8.66665V13.3333C7.33333 14.07 6.73667 14.6666 6 14.6666Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.8447H11.778C13.0053 11.8447 14 10.85 14 9.62268",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1113 12.956L10 11.8447L11.1113 10.734",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 2.44464H4.8885C3.66117 2.44464 2.6665 3.43931 2.6665 4.66664",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55518 1.33331L6.66651 2.44465L5.55518 3.55531",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44133 3.356C8.628 3.46667 8 4.15667 8 5C8 5.92067 8.74667 6.66667 9.66667 6.66667H13.3333C14.07 6.66667 14.6667 6.07 14.6667 5.33333C14.6667 4.59667 14.07 4 13.3333 4C13.3333 2.89533 12.438 2 11.3333 2C10.4547 1.99933 9.70933 2.56733 9.44133 3.356Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19340_58129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogNetworkDefault as ReactComponent };
export default __webpack_public_path__ + "log-network-default.svg";